import { isValidElement, type ReactNode } from "react";

interface SubjectEmojiProps {
  subjectEmoji: ReactNode;
  subjectColor: string;
  className?: string;
}

export default function SubjectEmoji({
  subjectEmoji,
  subjectColor,
  className = "w-10 h-10",
}: SubjectEmojiProps) {
  const usesSvgIcon = isValidElement(subjectEmoji);

  return (
    <span
      className={`${className} rounded-xl flex items-center justify-center flex-shrink-0 ${
        usesSvgIcon ? "p-1.5" : "text-[20px] bg-slate-50 border border-slate-100"
      }`}
      style={{ backgroundColor: usesSvgIcon ? subjectColor : undefined }}
      aria-hidden="true"
    >
      {subjectEmoji}
    </span>
  );
}
